import React from 'react'
import "./process.scss";
import shit from "../../assets/images/process/shit.avif";
import message from "../../assets/images/process/message1.svg";
import schedule from "../../assets/images/process/schedule.svg";
import work from "../../assets/images/process/work.svg";
import { useLanguage } from "../../LanguageContext";

const Process = () => {
    const { t } = useLanguage();
  return (
    <div className="processSection">
        
        <div className="processHeading">
            <h2>{t("process_title")}</h2>
            <p className="primary">{t("process_description")}</p>
        </div>

        <div className="processCards">
            <div className="processCard">
                <div className="processNumber"><p>1</p></div>
                <h3>{t("process_card_1_title")}</h3>
                <img src={message} alt="" />
                <p className="processText secondary">
                    {t("process_card_1_description")}
                </p>    
            </div>
            <div className="processCard">

            <div className="processNumber"><p>2</p></div>
                <h3>{t("process_card_2_title")}</h3>
                <img src={schedule} alt="" />
                <p className="processText secondary">
                   {t("process_card_2_description")}
                </p>

            </div>
            <div className="processCard">

            <div className="processNumber"><p>3</p></div>
                <h3>{t("process_card_3_title")}</h3>
                <img src={work} alt="" />
                <p className="processText secondary">
                   {t("process_card_3_description")}
                </p>

            </div>
        </div>

        <button>
            {t("process_button")}
        </button>
        
       

    </div>
  )
}

export default Process